'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ListView = require('./ListView');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ListView).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/ListView/index.js
// module id = 1224
// module chunks = 1